// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.practicepreferences.UpdateCommunicationsPreferencesRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateCommunicationsPreferencesRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'From Email is required' } })
	@GandalfValidator({ sizeString: { message: 'From Email must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfValidator({ email: { message: 'Invalid Email format' } })
	@GandalfProperty({ designType: String, isRequired: true })
	fromEmail!: string;

}
